











































































































































































































































import * as GoodsBlocks from './blocks'
import {
  apiShoppingCartAdd,
  apiShoppingCartQuantity,
  apiSubscribeCommodityArrivalReminderAdd,
  apiTradeGeneralTradePreOrder,
  ApiTradeGeneralTradePreOrderRequest,
  apiTradeSecKillTradeSeckillConfirmResult,
  apiTradeSecKillTradeSeckillPreOrder,
} from '@/api'
import {
  computed,
  nextTick,
  onActivated,
  onBeforeUnmount,
  ref,
  watch,
} from '@vue/composition-api'
import { currentSaleChannelId } from '@/channel'
import { defineClassComponent, useNewRoute, useQuery } from '@/hooks'
import { defineTvListeners } from '../utils'
import { getGoodsData, GoodsData } from '@/views/goods/utils'
import { goodsProvider } from '@/views/goods/provider'
import { loopUntil, range } from 'vtils'
import { navigateTo, redirectTo } from '@/router'
import { submit, Track } from '@/utils'

export default defineClassComponent(
  {
    components: {
      ...GoodsBlocks,
    },
  },
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          // 埋点页面名称
          page: 'TV-商品详情',
        }))

        useNewRoute(this.skuPickerVisible)

        // 打开弹窗返回恢复聚焦
        let prevFocusEl: any
        watch(
          () => this.skuPickerVisible.value,
          () => {
            if (this.skuPickerVisible.value) {
              prevFocusEl = document.querySelector('[focused]')
            } else {
              if (prevFocusEl) {
                nextTick(() => {
                  ctx.$tv.goTo(prevFocusEl)
                })
              }
            }
          },
        )

        // 提供商品数据
        goodsProvider.provide(this.goodsData)

        // 首次进入聚焦立即购买
        const offLoadingWatch = watch(
          () => this.loading.value,
          () => {
            if (!this.loading.value) {
              offLoadingWatch()
              nextTick(() => this.goToBuy())
            }
          },
        )

        onActivated(async () => {
          // 释放商品数据
          this.goodsData.value.$destroy?.()
          // 获取商品数据
          this.goodsData.value = (await getGoodsData({
            goodsId: this.query.id,
          }))!
          this.loading.value = false
        })

        onActivated(async () => {
          const { quantity } = await apiShoppingCartQuantity()
          this.cartCount.value = quantity
        })

        onBeforeUnmount(() => {
          // 释放商品数据
          this.goodsData.value.$destroy?.()
        })

        watch(
          () => this.skuPickerVisible.value,
          () => {
            if (this.skuPickerVisible.value) {
              nextTick(() => {
                ctx.$tv.setLimitingEl(ctx.$refs.skuDialog)
                this.goToSkuPickerAction()
              })
            } else {
              ctx.$tv.resetLimitingEl()
            }
          },
        )
      }

      // 加载状态
      loading = ref(true)

      query = useQuery<{
        // 商品 ID
        id: string
      }>()

      // 购物车数量
      cartCount = ref(0)

      // 商品数据
      goodsData = ref<GoodsData>({} as any)

      // 评论数据
      commentData = computed(() => this.goodsData.value.commentData)

      // 营销数据
      marketingData = computed(() => this.goodsData.value.marketingData)

      // 秒杀数据
      seckillData = computed(() => this.goodsData.value.seckillData)

      // SKU 选择是否可见
      skuPickerVisible = computed<boolean>({
        get: () => {
          return !!this.goodsData.value?.skuPicker?.visible
        },
        set: visible => {
          this.goodsData.value.skuPicker.visible = visible
        },
      })

      // 点击规格值
      handleSpecValueClick = (
        specValue: GoodsData['specList'][0]['values'][0],
        index: number,
      ) => {
        this.goodsData.value.selectedSku =
          this.goodsData.value.getVisibleSkuBySpecValue(specValue, index)
      }

      // 点击到货提醒
      handleNoticeClick = () => {
        submit(async $ => {
          $.start()
          await apiSubscribeCommodityArrivalReminderAdd({
            commodityId: this.goodsData.value.commodityId,
            skuId: this.goodsData.value.selectedSku.skuId,
          })
          await $.success('已添加到货提醒')
        })
      }

      // 点击立即购买
      handleBuyClick = () => {
        submit(async $ => {
          $.start('正在下单...')

          // 检测商品是否下架
          const goodsStatus = await this.goodsData.value.checkGoodsStatus()
          if (!goodsStatus) {
            await $.fail('商品已下架，看看其他好货吧', 2000)
            return
          }

          // 秒杀下单
          if (this.goodsData.value.isSeckill) {
            await apiTradeSecKillTradeSeckillPreOrder({
              activityId: this.seckillData.value.activityId,
              preOrderType: 3 as any,
              sessionId: this.seckillData.value.sessionId,
              skuInfo: [
                {
                  activityId: this.seckillData.value.activityId,
                  commodityId:
                    this.seckillData.value.commodityInfo.commodityId,
                  count: this.goodsData.value.buyCount,
                  skuId: this.goodsData.value.selectedSku.skuId,
                  // @ts-ignore
                  sellChannelId: currentSaleChannelId,
                },
              ],
            })
            const res = await loopUntil(
              () => apiTradeSecKillTradeSeckillConfirmResult(),
              res => res.confirmState !== 0,
              {
                retryDelay: range(100, 500, 10),
              },
            )
            if (res.confirmState === 2) return $.fail(res.msg!)
            const data = res.result
            // 弹窗进行了路由改造，直接 redirect 过去即可
            redirectTo('TvOrderPlace', {
              type: 'seckill',
              data: JSON.stringify(data),
              preOrderRequestData: JSON.stringify({}),
            })
          }
          // 普通下单
          else {
            const preOrderRequestData: ApiTradeGeneralTradePreOrderRequest = {
              preOrderType: 2 as any,
              skuInfo: [
                {
                  commodityId: this.goodsData.value.commodityId,
                  count: this.goodsData.value.buyCount,
                  skuId: this.goodsData.value.selectedSku.skuId,
                  sellChannelId: currentSaleChannelId,
                },
              ],
            }
            const data = await apiTradeGeneralTradePreOrder(
              preOrderRequestData,
            )
            // 弹窗进行了路由改造，直接 redirect 过去即可
            redirectTo('TvOrderPlace', {
              type: 'normal',
              data: JSON.stringify(data),
              preOrderRequestData: JSON.stringify(preOrderRequestData),
            })
          }

          this.goodsData.value.closeSkuPicker()
        })
      }

      // 点击加入购物车
      handleAddCartClick = () => {
        submit(async $ => {
          $.start('加入购物车中...')
          await apiShoppingCartAdd({
            commodityId: this.goodsData.value.commodityId,
            quantity: this.goodsData.value.buyCount,
            skuId: this.goodsData.value.selectedSku.skuId,
            sellChannelId: currentSaleChannelId,
            address: {
              provinceCode: '',
              cityCode: '',
              districtCode: '',
              detail: '',
            },
          })
          this.goodsData.value.skuPicker.callback?.()
          await $.success('加入购物车成功')
        })
      }

      // 跳到操作
      goToActions = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.actions, index)
      }

      // 跳到购买
      goToBuy = () => {
        this.goToActions(0)
      }

      // 跳到菜单
      goToMenu = (index: number) => {
        ctx.$tv.goTo(ctx.$refs.menu, index)
      }

      // 跳到 SKU 选择器操作
      goToSkuPickerAction = () => {
        ctx.$tv.goTo(ctx.$refs.skuPickerActions, 0)
      }

      // 操作监听器
      actionsListeners = defineTvListeners(({ type, isLast, el }) => {
        switch (type) {
          case 'click':
            const action: '加入购物车' | '立即购买' | '已售罄' | '立即秒杀' =
              el.textContent!.trim() as any
            if (action === '加入购物车') {
              this.goodsData.value.showSkuPicker({
                action: 'addCart',
              })
            } else if (action === '立即购买' || action === '立即秒杀') {
              this.goodsData.value.showSkuPicker({
                action: 'buy',
              })
            }
            break
          case 'right':
            if (isLast) {
              this.goToMenu(0)
            }
            break
          default:
            break
        }
      })

      // 菜单监听器
      menuListeners = defineTvListeners(({ type, el, index, isLast }) => {
        switch (type) {
          case 'right':
            if (isLast) {
              this.goToMenu(-1)
            } else {
              this.goToMenu(index + 1)
            }
            break
          case 'left':
            this.goToActions(-1)
            break
          case 'click':
            const action: '购物车' | '店铺' | '收藏' | '已收藏' =
              el.textContent!.trim() as any
            if (action === '购物车') {
              navigateTo('TvCartIndex')
            } else if (action === '店铺') {
              navigateTo('TvMartIndex', {
                id: this.goodsData.value.merchantId,
              })
            } else if (action === '收藏' || action === '已收藏') {
              this.goodsData.value.favorite()
            }
            break
          default:
            break
        }
      })
    },
)
